import React, {useEffect, useState} from 'react';
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import {Autocomplete, TextField} from "@mui/material";
import moment from "moment";
import Loader from "../BlueButton/Loader.js";
import {useDispatch, useSelector} from "react-redux";
import BlueButton from "../BlueButton/BlueButton.js";
import Api from "../../Api.js";
import {dayOffAddLocalRequest} from "../../store/actions/dayoff.js";
import qs from "query-string";
import ErrorToast from "../BlueButton/ErrorToast.js";
import SuccessToast from "../BlueButton/SuccessToast.js";

function AddDayOff({onHide, show}) {
    const [submitted, setSubmitted] = useState(false)
    const dispatch = useDispatch()

    const [form, setForm] = useState({
        title: '',
        text: '',
        start_date: moment(new Date()).format("YYYY-MM-DDTHH:mm"),
        end_date: moment(new Date()).add(1, 'day').format("YYYY-MM-DDTHH:mm")

    })
    const handleChange = (name, val) => {
        setForm((prevState) => {
            if (name === 'start_date') {
                const newStartDate = moment(val);
                // Automatically set end date to the next day
                const nextDay = newStartDate.clone().add(1, 'day');
        
                return {
                    ...prevState,
                    start_date: newStartDate.format("YYYY-MM-DDTHH:mm"),
                    end_date: nextDay.format("YYYY-MM-DDTHH:mm"),
                };
            }
        
            if (name === 'end_date') {
                const newEndDate = moment(val);
                const currentStartDate = moment(prevState.start_date);
        
                // Only validate that end date is not before start date
                // Don't change start date automatically
                if (newEndDate.isBefore(currentStartDate)) {
                    return {
                        ...prevState,
                        end_date: currentStartDate.format("YYYY-MM-DDTHH:mm"),
                    };
                } else {
                    return {
                        ...prevState,
                        end_date: newEndDate.format("YYYY-MM-DDTHH:mm"),
                    };
                }
            }
        
            return {
                ...prevState,
                [name]: val,
            };
        });
    }
    const login = useSelector((state) => state.manager.employee);
    const query = qs.parse(location.search, {arrayFormat: 'comma'});

    const handleAdd = async (name, val) => {
        try {
            setSubmitted(true)
            const formData = new FormData()
            Object.entries(form).forEach(([key, value]) => {
                formData.append(key, value);
            });
            formData.append('creator', login.user_id);
            formData.append('approved', 0);
            formData.append('created_date', moment(new Date()).format("YYYY-MM-DDTHH:mm"));
            await Api.addDayoff(formData)
            let querystring = qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })
            const {data} = await Api.getDayOff(querystring)
            dispatch(dayOffAddLocalRequest(data))
            SuccessToast()
            onHide()
        } catch (e) {
            ErrorToast()
        }
    }

    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>Ավելացնել նոր Day Off</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div
                                className={!form.title && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='title'
                                    value={form.title}
                                    onChange={(e) => handleChange('title', e.target.value)}
                                    label="Անվանում"
                                    multiline
                                    variant="outlined"
                                    error={!form.title && submitted}
                                    className={!form.title && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!form.title && submitted &&
                                <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            <div
                                className={!form.text && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    name='text'
                                    value={form.text}
                                    onChange={(e) => handleChange('text', e.target.value)}
                                    label="Պատճառ"
                                    multiline
                                    variant="outlined"
                                    error={!form.title && submitted}
                                    className={!form.title && submitted ? "validation-outlined-input" : "outlined-helperText"}
                                />
                                {!form.text && submitted &&
                                <div className="validation valid-center">{word['empty_error']}</div>}
                            </div>
                            <div className='input-validation'>
                                <TextField
                                    // disabled
                                    id="datetime-local"
                                    value={form.start_date}
                                    label="Ժամանակացույց սկիզբ"
                                    type="datetime-local"
                                    onChange={(ev) => handleChange('start_date', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className='input-validation'>
                                <TextField
                                    // disabled
                                    value={form.end_date}
                                    id="datetime-local"
                                    label="Ժամանակացույց ավարտ"
                                    type="datetime-local"
                                    onChange={(ev) => handleChange('end_date', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            {submitted ? <div className="disable-loader"><Loader size={30}/></div> : null}
                            <div className='button-line'>
                                <BlueButton disabled={submitted}
                                            title={word.create}
                                            buttonStyle={!submitted ? "blue-button" : "blue-button blue-button-disabled"}
                                            onChangeValue={() => handleAdd()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddDayOff;